/* IsLoved — widow guard
 * Prevents single-word last lines ("widows"). Native text-wrap:pretty/balance
 * handles most cases; this is the backstop that gently scales type down
 * (to a 88% floor) until the final word is no longer stranded alone.
 *
 * Usage: add this script to a page's <helmet> and put a `data-widow-scope`
 * attribute on the container whose text should be guarded. Re-runs on font
 * load, resize, and DOM mutations automatically.
 */
(function () {
  if (window.__ilWidowGuard) return;

  var SEL = 'h1,h2,h3,h4,h5,h6,p,li,blockquote,figcaption,dd,[data-widow]';

  // inject the native rules once
  function injectCSS() {
    if (document.getElementById('il-widow-css')) return;
    var s = document.createElement('style');
    s.id = 'il-widow-css';
    s.textContent =
      '[data-widow-scope] h1,[data-widow-scope] h2,[data-widow-scope] h3,' +
      '[data-widow-scope] h4,[data-widow-scope] h5,[data-widow-scope] h6{text-wrap:balance;}' +
      '[data-widow-scope] p,[data-widow-scope] li,[data-widow-scope] blockquote,' +
      '[data-widow-scope] figcaption,[data-widow-scope] dd,[data-widow-scope] [data-widow]{text-wrap:pretty;}';
    (document.head || document.documentElement).appendChild(s);
  }

  function lastTextNode(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var node = null;
    while (w.nextNode()) { if (w.currentNode.textContent.trim()) node = w.currentNode; }
    return node;
  }

  function isWidow(el) {
    var tn = lastTextNode(el);
    if (!tn) return false;
    var trimmed = tn.textContent.replace(/\s+$/, '');
    var sp = trimmed.lastIndexOf(' ');
    if (sp <= 0) return false;
    var r = document.createRange();
    r.setStart(tn, sp + 1); r.setEnd(tn, trimmed.length);
    var lastWordTop = r.getBoundingClientRect().top;
    r.setStart(tn, sp - 1); r.setEnd(tn, sp);
    var prevTop = r.getBoundingClientRect().top;
    return lastWordTop > prevTop + 1;
  }

  function deWidow(el) {
    var text = (el.textContent || '').trim();
    if (text.split(/\s+/).length < 3) return;
    if (el.dataset.dwOrig === undefined) el.dataset.dwOrig = el.style.fontSize || '';
    el.style.fontSize = el.dataset.dwOrig;
    var base = parseFloat(getComputedStyle(el).fontSize) || 16;
    var floor = base * 0.88;
    if (!isWidow(el)) return;
    var size = base, guard = 0;
    while (isWidow(el) && size > floor && guard < 24) {
      size -= base * 0.01;
      el.style.fontSize = size + 'px';
      guard++;
    }
    if (isWidow(el)) el.style.fontSize = el.dataset.dwOrig;
  }

  var raf = 0;
  function scan() {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var scopes = document.querySelectorAll('[data-widow-scope]');
        for (var i = 0; i < scopes.length; i++) {
          var els = scopes[i].querySelectorAll(SEL);
          for (var j = 0; j < els.length; j++) deWidow(els[j]);
        }
      });
    });
  }

  function start() {
    injectCSS();
    scan();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(scan);
    window.addEventListener('resize', scan, { passive: true });
    var mo = new MutationObserver(scan);
    mo.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }

  window.__ilWidowGuard = { scan: scan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
